// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__ixaYK","foto":"styles_foto__QGp5i"};